import { Navigate } from "react-router";
import { useLoginContext } from "../context/loginContextProvider";

export default function RequireLogin({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isLoggedIn } = useLoginContext();

  // If not logged in, redirect to login page
  if (isLoggedIn === false) {
    return <Navigate to="/login" replace />;
  }

  // If still checking login status, show nothing
  if (isLoggedIn === undefined) {
    return null;
  }

  // If logged in, render the children components
  return <>{children}</>;
}
